import {
  fetchCalendarEvents,
  updateCalendarEventByLinkEntities,
  loadMoreCalendarEventsByEntity,
  clearCalendarEvents,
} from '../../routines/calendarRoutines';

const initialAttributes = {
  items: [],
  loading: false,
  isSuccess: false,
  paginationDataForActivityFeed: {},
  loadingMore: false,
};

const initialState = {
  events: { ...initialAttributes },

  initialCalendarEventLinkEntitiesState: {
    loading: false,
    error: null,
    organizations: [],
    accounts: [],
  },
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchCalendarEvents.TRIGGER:
      return {
        ...state,
        events: {
          ...state.events,
          loading: true,
          isSuccess: false,
        },
      };

    case fetchCalendarEvents.SUCCESS: {
      const { page, pageSize, totalCount, events } = action.payload.data;
      const formattedEvents = events.map((event) => ({
        type: 'calendar',
        orderBy: event.eventStartTime,
        data: event,
      }));
      return {
        ...state,
        events: {
          ...state.events,
          items: formattedEvents,
          loading: false,
          isSuccess: true,
          paginationDataForActivityFeed: {
            page,
            pageSize,
            totalCount,
          },
        },
      };
    }
    case loadMoreCalendarEventsByEntity.TRIGGER:
      return {
        ...state,
        events: {
          ...state.events,
          loadingMore: true,
          isSuccess: false,
        },
      };
    case loadMoreCalendarEventsByEntity.SUCCESS: {
      const { page, pageSize, totalCount, events } = action.payload.data;
      const formattedEvents = events.map((event) => ({
        type: 'calendar',
        orderBy: event.eventStartTime,
        data: event,
      }));
      return {
        ...state,
        events: {
          ...state.events,
          items: [...state.events.items, ...(formattedEvents ?? [])],
          loadingMore: false,
          isSuccess: true,
          paginationDataForActivityFeed: {
            page,
            pageSize,
            totalCount,
          },
        },
      };
    }

    case loadMoreCalendarEventsByEntity.FAILURE:
      return {
        ...state,
        events: {
          ...state.events,
          loadingMore: false,
          isSuccess: false,
        },
      };
    case fetchCalendarEvents.FAILURE:
      return {
        ...state,
        events: {
          ...state.events,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case updateCalendarEventByLinkEntities.TRIGGER:
      return {
        ...state,
        initialCalendarEventLinkEntitiesState: {
          ...state.initialCalendarEventLinkEntitiesState,
          loading: true,
          isSuccess: false,
        },
      };

    case updateCalendarEventByLinkEntities.SUCCESS: {
      const { data } = action.payload;
      const {
        unlinkedAccounts: updatedUnlinkedAccounts,
        linkedAccounts: updatedLinkedAccounts,
        unlinkedOrganizations: updatedUnlinkedOrganizations,
        linkedOrganizations: updatedLinkedOrganizations,
        eventId,
      } = data;
      const newEventList = [...state.events.items];
      const selectedEventIndex = newEventList.findIndex(
        ({ data: event }) => event.eventId === eventId
      );
      if (selectedEventIndex !== -1) {
        const updatedEvent = {
          ...newEventList[selectedEventIndex].data,
          updatedUnlinkedAccounts,
          updatedLinkedAccounts,
          updatedUnlinkedOrganizations,
          updatedLinkedOrganizations,
        };
        newEventList[selectedEventIndex] = {
          ...newEventList[selectedEventIndex],
          data: updatedEvent,
        };
      }

      return {
        ...state,
        initialCalendarEventLinkEntitiesState: {
          ...state.initialCalendarEventLinkEntitiesState,
          loading: false,
          isSuccess: true,
        },
        events: {
          ...state.events,
          items: newEventList,
          loading: false,
          isSuccess: true,
        },
      };
    }

    case updateCalendarEventByLinkEntities.FAILURE:
      return {
        ...state,
        initialCalendarEventLinkEntitiesState: {
          ...state.initialCalendarEventLinkEntitiesState,
          loading: false,
          isSuccess: false,
        },
      };
    case clearCalendarEvents.TRIGGER:
      return {
        ...state,
        events: {
          ...state.events,
          items: [],
          loading: false,
          isSuccess: false,
          paginationDataForActivityFeed: {},
        },
      };
    default:
      return state;
  }
};

export default calendarReducer;
